export enum BIDepositDecisionType {

    DoNothing = "Do Nothing",
    KYC = "KYC",
    KYCInAppropriate = "KYC InAppropriate",
    InAppropriate = "InAppropriate Popup",
    Deposit = "Deposit"
}
